<template>
  <v-sheet
    v-if="!printMode"
    style="position: absolute; top: 0px; width: 100%; z-index: 2 !important"
  >
    <v-divider></v-divider>
    <v-breadcrumbs :items="items" class="py-2">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          :disabled="item.disabled"
          :replace="item.replace"
          :href="item.href ? '#' + item.href : ''"
          :class="item.accent ? 'accent--text' : ''"
          @click="item.click ? item.click() : null"
          >{{ item.text.toUpperCase() }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <v-divider></v-divider>
  </v-sheet>
</template>

<script>
import { mapState } from "vuex";
// import AccountLog from "@/api/account_log";

export default {
  name: "Breadcrumbs",

  props: { items: Array }, // accent仅在disable为false且href为空时才将文字显示为accent颜色

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["printMode"]),
  },

  watch: {
    items: {
      immediate: true,
      handler() {
        if (
          this.items &&
          this.items.length > 0 &&
          !this.items.find((item) => !item.text) // 有些item赋值有延时，等赋值结果再调用日志
        ) {
          // console.log(this.items.map((item) => item.text).join(" / "));
          // AccountLog.pageAccess(
          //   this.items.map((item) => item.text).join(" / ")
          // );
        }
      },
    },
  },
};
</script>
